import _ from "lodash";
import {
    handleChangeActionType,
    handleChangeAllActionType,
    handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  makuleringFraDato: "",
  makuleringTilDato: "",
  makuleringFraDatoValidationErrorText: null,
  makuleringTilDatoValidationErrorText: null,
  ileggelseFraDato: "",
  ileggelseTilDato: "",
  ileggelseFraDatoValidationErrorText: null,
  ileggelseTilDatoValidationErrorText: null,
  tjenestenummer: "",
  tjenestenummerValidationErrorText: null,
  makulertAv: "",
  filterValidationErrorText: null,
};

export default function makuleringerFilterFormReducer(
  state = {
    ...INITIAL_STATE,
    validationError: { ...INITIAL_STATE.validationError },
  },
  action,
) {
  switch (action.type) {
    case handleChangeActionType("RAPPORT_MAKULERINGER_FILTER_FORM"):
      _.set(state, action.variableName, action.payload);
      return { ...state };
    case handleChangeAllActionType("RAPPORT_MAKULERINGER_FILTER_FORM"):
      return { ...action.payload };
    case handleChangeToInitStateActionType("RAPPORT_MAKULERINGER_FILTER_FORM"):
      return {
        ...INITIAL_STATE,
        validationError: { ...INITIAL_STATE.validationError },
      };
    default:
      return state;
  }
}
